import axios from 'axios';

const opensearchEndpoint = process.env.VUE_APP_OPENSEARCH_URL;
const DEFAULT_SIZE = 40000

const indexName = localStorage.getItem('sentencesIndex');


export const articleService = {
    getArticles
};

async function getArticles() {
    let articles = [];

    // Encode the credentials in Base64
    const credentials = Buffer.from(`admin:${process.env.VUE_APP_OPENSEARCH_PASSWORD}`).toString('base64');
    const authHeader = `Basic ${credentials}`;

    // Retrieve data from OpenSearch index
    const query = {
        size: DEFAULT_SIZE,
        query: {
            match_all: {}, // Adjust the query as needed
        },
    };

    try {
        const apiUrl = `${opensearchEndpoint}/${indexName}/_search`;

        const response = await axios.post(apiUrl, query, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json', // Adjust the content type based on your API requirements
            },
            withCredentials: false,
        });

        articles = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
    } catch (error) {
        console.error('Error retrieving data from OpenSearch:', error.response ? error.response.data : error.message);
        return articles;
    }

    return articles;
}


// WEBPACK FOOTER //
// ./src/services/articleService.js